import React from 'react';
import Carousel from 'react-material-ui-carousel';
import { Paper, Grid } from '@mui/material';
import Loader from '../UI/loader/Loader';
import { useGetCoupons } from '../../hooks/useGetCoupons';
import { Coupons } from '../../models/app';
import useIsMobile from '../../hooks/useIsMobile';

const CouponsSlider = () => {
  const { coupons, couponsLoading, couponsError } = useGetCoupons();

  const parseHTML = (htmlString: string) => {
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
  };
  
  const {isMobile} = useIsMobile();
  
//   if (couponsLoading) return <Loader />;
  const groupedCoupons = groupCoupons(coupons ?? [], isMobile ? 1 : 2);
  return (
    <div style={{ paddingTop: "15px", position: 'relative', margin: '0 auto' }}>
      <Carousel
        autoPlay={true}
        animation="slide"
        indicators={false}
        navButtonsAlwaysVisible={true}
        cycleNavigation={true}
        interval={9000}
        navButtonsProps={{
            style: isMobile ? 
            {
                width: 30,
                height: 30,
                padding: 0, 
                margin: 0,
          }: {}
        }}
      >
        {groupedCoupons.map((group, index) => (
            <Grid container key={index} spacing={isMobile? 0: 5} justifyContent="center" style={{ transition: 'transform 9.0s ease' }}>
                {group.map((coupon) => (
                    <Grid item xs={8} sm={4} md={4.5} key={coupon.SystemId} style={{ transition: 'all 9.0s ease-in-out' }}>
                        <Paper style={{
                            height: '100%',
                            padding: '5px',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                            overflow: 'hidden',
                            transition: 'box-shadow 9.0s ease-in-out'
                        }}
                        onMouseOver={({currentTarget}) => {currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';}}
                        onMouseOut={({currentTarget}) => {currentTarget.style.boxShadow = 'none';}}
                        >
                            {parseHTML(coupon.MarketingText)}
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        ))}
      </Carousel>
    </div>
  );
};


interface CouponItemProps {
    coupon: Coupons;
    parseHTML: (htmlString: string) => JSX.Element;
}

const CouponItem: React.FC<CouponItemProps> = ({ coupon, parseHTML }) => (
    <Paper
        style={{
            height: '100%',
            padding: '5px',
            border: '1px solid #ccc',
            borderRadius: '5px',
            overflow: 'hidden',
        }}
    >
        {parseHTML(coupon.MarketingText)}
    </Paper>
);

// Updated to not fill coupons but directly group them.
function groupCoupons(coupons: Coupons[], groupSize: number): Coupons[][] {
    let result: Coupons[][] = [];
    for (let i = 0; i < coupons.length; i += groupSize) {
        result.push(coupons.slice(i, i + groupSize));
    }
    return result;
}

export default CouponsSlider;
